import { useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { NOTIFY } from "../based/Constants";
import CommonModal from "../based/Modal";
import { Notify } from "../based/Notify";
import OrderServices from "../based/services/OrderServices";

function DirectReturnModal({ show, onClose }) {
    const history = useHistory();
    const [orderId, setOrderId] = useState("");

    const checkWhetherOrderIdNumber = async (orderIdNumber) => {
        const [err, data] = await OrderServices.GetOrderIdByWhetherOrderIdNumber(orderIdNumber);
        return data;
    };

    return (
        <CommonModal
            size="md"
            show={show}
            onClose={onClose}
            onConfirm={async () => {
                let checkWhether = await checkWhetherOrderIdNumber(orderId);
                if (checkWhether > 0) {
                    history.push(`/return-order-edit/${checkWhether}`);
                } else {
                    Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Vui lòng nhập mã đơn hàng để tạo hoàn hàng");
                }
            }}
            title="Nhập mã đơn để tạo hoàn hàng"
        >
            <Wrapper>
                <div className="form-group">
                    <label htmlFor="orderId">Mã đơn hàng/Mã hệ thống</label>
                    <input
                        type="text"
                        id="orderId"
                        placeholder="Nhập mã đơn hàng"
                        value={orderId || ""}
                        onChange={(e) => {
                            setOrderId(e.target.value);
                        }}
                        className="form-control"
                    />
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default DirectReturnModal;

const Wrapper = styled.div``;
